import PropTypes from "prop-types";
import ConfirmModal from "./ConfirmModal";

export default function ReopenTicketModal({
  isOpen,
  onClose,
  onConfirm,
  message = "Are you sure you want to re-open this ticket?",
  isSubmitting = false,
}) {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Confirm"
      message={message}
      subMessage="You can continue editing services and payments."
      cancelLabel="Cancel"
      confirmLabel="Re-open"
      confirmingLabel="Re-opening..."
      isSubmitting={isSubmitting}
    />
  );
}

ReopenTicketModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string,
  isSubmitting: PropTypes.bool,
};
